import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators, FormBuilder, FormControl } from '@angular/forms';
import { AuthService } from '../../../../service/auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-registrationForm',
  templateUrl: './registrationForm.component.html',
  styleUrls: ['./registrationForm.component.css']
})
export class RegistrationFormComponent implements OnInit {
  public registrationForm: FormGroup;
  loading: boolean;
  data: Object;
  step: number;
  participate = false;
  nameErr: string
  emailErr: string
  passwordErr: string
  email2Err: string
  securityErr: string
  codes=[]
  //translations
  lan: string
  err1: string
  err2: string
  err3: string
  err4: string
  err5: string
  noVoucherUser: Object;

  showAdditionalInfo: boolean = false;

  constructor(
    private builder: FormBuilder,
    private authService: AuthService,
    private _snackBar: MatSnackBar,
    public translate: TranslateService,
    private router: Router,
  ) {
    this.getTranslatedStrings()
    this.lan = localStorage.getItem('lan')
  }

  getTranslatedStrings(){
    this.translate.get(['REG_ERR1', 'REG_ERR2', 'REG_ERR3', 'REG_ERR4', 'REG_ERR5', 'REG_P4', 'FP_P3'])
    .subscribe(translations => {
        this.err1 = translations['REG_ERR1']
        this.err2 = translations['REG_ERR2']
        this.err3 = translations['REG_ERR3']
        this.err4 = translations['REG_ERR4']
        this.err5 = translations['REG_ERR5']
    })
}

  ngOnInit() {
    this.authService.getAllCodes().then((data: any) => {
      this.codes = data.body;
    });

    // Limpiar los datos del usuario al entrar a la página de Login. Por el
    // momento se hace acá, pero después debiese pasar en los guards o en algún
    // otro lado
    // Setear el formulario para iniciar sesión
    this.step = 1
    this.registrationForm = this.builder.group({
      email: new FormControl(null, [
        Validators.required,
        Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]),
      password: new FormControl('', [
        Validators.required]),
      name: new FormControl('', [
        Validators.required]),
      securitycode: new FormControl('', [
        Validators.required]),
        // lcFlag: new FormControl('', []),

    });

  }
  get isDisabled() {
    return !(this.participate);
  }
  delete(code){
    this.authService.deleteCode(code).then((data:any)=>{/*console.log(data)*/})
  }
  register() {

    if (this.registrationForm.controls.email.value === null) {
      this.emailErr = this.err2
    }
    else if (this.registrationForm.controls.email.status === "INVALID") {
      this.emailErr = this.err3
    }
    if (this.registrationForm.controls.password.value === '') {
      this.passwordErr = this.err4
    }
    if (this.registrationForm.controls.securitycode.value === null) {
      this.securityErr = 'Security code is a required field!';
    }
    if (this.registrationForm.controls.name.value === '') {
      this.nameErr = this.err5
    }

    if (!this.nameErr && !this.passwordErr && !this.emailErr && !this.securityErr) {
      console.log(this.lan)
      //No error
      this.data = {
        email: this.registrationForm.controls.email.value,
        password: this.registrationForm.controls.password.value,
        language: this.lan,
        // lcFlag:this.registrationForm.controls.lcFlag.value
      };
      this.loading = true
      let control=false
      console.log(this.registrationForm.controls.securitycode.value);
      for (let i in this.codes){
          if(this.codes[i].code===this.registrationForm.controls.securitycode.value || this.registrationForm.controls.securitycode.value==='FeliciDiNuovo'
          || this.registrationForm.controls.securitycode.value==='FelizDeNuevo' || this.registrationForm.controls.securitycode.value==='HappyAgainTrial'){
            control=true
          }
      }
      if (control){
      this.authService.createUser(this.data)
        .then(resp => {
          this.loading = false
          if (resp.status == 200) {
            this.registrationForm = this.builder.group({
              name: [null, [Validators.required]],
              email: [null, [Validators.required]],
              password: [null, [Validators.required]],
              securitycode: [null, [Validators.required]],
              // lcFlag: [null, []],
            });
            this.step++
          }
        })
        .catch(e => {
          this.loading = false
          if (e.status == 409) {
            this._snackBar.open(this.err1, "", {
              duration: 5000,
            });
          }
        })
        if(this.registrationForm.controls.securitycode.value!='FeliciDiNuovo'&&this.registrationForm.controls.securitycode.value!='FelizDeNuevo'&&this.registrationForm.controls.securitycode.value!='HappyAgainTrial'){
        this.delete(this.registrationForm.controls.securitycode.value)
        }
        if(this.registrationForm.controls.securitycode.value==='FeliciDiNuovo'){
          this.noVoucherUser={
            email: this.registrationForm.controls.email.value,
            nation: 'IT',
           }
          this.authService.createNoVoucherUser(this.noVoucherUser)
        }
        if(this.registrationForm.controls.securitycode.value==='FelizDeNuevo'){
          this.noVoucherUser={
            email: this.registrationForm.controls.email.value,
            nation: 'SP',
           }
          this.authService.createNoVoucherUser(this.noVoucherUser);
        }
        if(this.registrationForm.controls.securitycode.value==='HappyAgainTrial'){
          this.noVoucherUser={
            email: this.registrationForm.controls.email.value,
            nation: 'EN',
           }
          this.authService.createNoVoucherUser(this.noVoucherUser);
        }
      }
      else {
        this.loading = false
        console.log(this.registrationForm.controls.securitycode.value)
        this._snackBar.open("Invalid Code", "", {
          duration: 5000,
        });
      }
    }
  }



  showForm() {
    this.step++
  }

  clearNameErr() {
    this.nameErr = ''
  }

  clearEmailErr() {
    this.emailErr = ''
  }

  clearEmail2Err() {
    this.email2Err = ''
  }

  clearPasswordErr() {
    this.passwordErr = ''
  }

  focusOutCheck(field: string) {
    switch (field) {
      case 'name':
        if (this.registrationForm.controls.name.value === '') {
          this.nameErr = this.err5
        }
        break
      case 'email':
        if (this.registrationForm.controls.email.value === null) {
          this.emailErr = this.err2
        }
        else if (this.registrationForm.controls.email.status === "INVALID") {
          this.emailErr = this.err3
        }
        break
      case 'password':
        if (this.registrationForm.controls.password.value === '') {
          this.passwordErr = this.err4
        }
        break
      case 'Security Code':
        if (this.registrationForm.controls.securitycode.value === '') {
          this.securityErr = this.err5
        }
        break
      default:
        throw new Error('Unknown field name')
    }
  }

  toggleAdditionalInfo() {
    this.showAdditionalInfo = !this.showAdditionalInfo;
  }

  openResend() {
    this.router.navigate(['/resend-link'])
  }

}
